import {atom, useAtom, useAtomValue} from "jotai";
import {type UseMutateFunction, useMutation, useSuspenseQuery} from "@tanstack/react-query";
import {ScanAtom} from "../3-perform-scan/ScanAtom.tsx";
import {ToolApi} from "../../util/ToolApi.tsx";
import {uploadReplacer} from "./uploadReplacer.ts";

export type UploadState = "idle" | "uploading" | "error" | "success"
export const UploadedAtom = atom<UploadState>("idle")

function useUploadToken() {
    return useSuspenseQuery({
        queryKey: ["upload-token"],
        queryFn: async () => {
            const response = await ToolApi.get<{token: string}>("generateToken")
            return response.data.token
        }
    })
}

type UploadMethod = UseMutateFunction<void, Error, string>
export function useUpload(): [UploadState, UploadMethod, unknown?] {
    const [uploaded, setUploaded] = useAtom(UploadedAtom)
    const uploadTokenResponse = useUploadToken()
    const uploadToken = uploadTokenResponse.data
    const scanResult = useAtomValue(ScanAtom)
    const uploadQuery = useMutation({
        mutationKey: ["upload", uploadToken],
        gcTime: Infinity,
        mutationFn: async (label: string) => {
            try {
                setUploaded("uploading")
                await ToolApi.post("submitReport", {
                    customerIdentifier: label,
                    token: uploadToken,
                    reportContents: JSON.stringify(scanResult, uploadReplacer, 2)
                })
                setUploaded("success")
            } catch(e) {
                console.error("Error while uploading report", uploadToken, scanResult, e)
                setUploaded("error")
                throw e
            }
        }
    })
    return [uploaded, uploadQuery.mutate, uploadQuery.error]
}